module.exports = __webpack_public_path__ + "static/img/lmy_2.89894ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/lmy_2.jpg
// module id = mboD
// module chunks = 15